import { ArrowRight, Fuel, BarChart3, Truck, Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

export default function HeroSection({ onBookingOpen }) {
  const { t } = useLanguage();
  const hero = t("hero");
  const areas = t("practiceAreas.items") || [];

  return (
    <section id="hero" data-testid="hero-section" className="relative bg-[#f5f0e8] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-28 pb-16 relative">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-4 items-center min-h-[75vh]">
          <div className="relative z-10 animate-fade-in-left">
            <p className="text-[#1a5c4a] text-xs uppercase tracking-[0.3em] mb-6 font-semibold">
              {hero.subtitle}
            </p>
            <h1
              data-testid="hero-headline"
              className="font-heading text-3xl sm:text-4xl lg:text-5xl xl:text-[3.5rem] font-extrabold text-[#1a1a2e] leading-[1.1] tracking-[-0.02em] mb-8"
            >
              {hero.headline}
            </h1>
            <p className="text-[#4a4540] text-base md:text-lg max-w-lg leading-relaxed mb-6">
              {hero.description}
            </p>
            <div className="bg-[#1a5c4a]/10 border-l-4 border-[#1a5c4a] rounded-r-lg px-5 py-4 mb-10 max-w-lg">
              <p className="text-[#1a5c4a] font-semibold text-sm md:text-base">
                ✓ Te registramos en el Programa de Autoconsumo de CNE, para que puedas operar mientras tu trámite transcurre.
              </p>
            </div>
            <Button
              data-testid="hero-schedule-btn"
              onClick={onBookingOpen}
              className="bg-[#1a5c4a] text-white hover:bg-[#154a3c] rounded-full px-10 py-6 text-sm font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-0.5"
            >
              {hero.cta} <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </div>
          <div className="relative flex justify-center lg:justify-end animate-fade-in-right">
            <div className="relative w-full max-w-lg">
              {/* Service Cards Visual */}
              <div className="relative w-full h-[520px] lg:h-[580px] flex items-center justify-center">
                <div className="absolute inset-0 bg-gradient-to-br from-[#1a5c4a]/10 to-transparent rounded-3xl"></div>
                <div className="relative z-10 grid grid-cols-2 gap-4 p-6">
                  <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 col-span-2">
                    <Briefcase className="h-10 w-10 text-[#1a5c4a] mb-3" />
                    <h3 className="font-bold text-[#1a1a2e] text-lg mb-1">Gestión integral</h3>
                    <p className="text-sm text-[#4a4540]">Permisos + Controles + Suministro</p>
                  </div>
                  <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                    <Fuel className="h-10 w-10 text-[#1a5c4a] mb-3" />
                    <h3 className="font-bold text-[#1a1a2e] text-base mb-1">Permisos CNE</h3>
                    <p className="text-xs text-[#4a4540]">Autoconsumo y reportes</p>
                  </div>
                  <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                    <BarChart3 className="h-10 w-10 text-[#1a5c4a] mb-3" />
                    <h3 className="font-bold text-[#1a1a2e] text-base mb-1">Controles SAT</h3>
                    <p className="text-xs text-[#4a4540]">Volumétricos certificados</p>
                  </div>
                  <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 col-span-2">
                    <Truck className="h-10 w-10 text-[#1a5c4a] mb-3" />
                    <h3 className="font-bold text-[#1a1a2e] text-lg mb-1">Suministro de combustible</h3>
                    <p className="text-sm text-[#4a4540]">Comercializadores autorizados por CNE</p>
                  </div>
                </div>
                {/* Background decoration */}
                <div className="absolute -right-10 -bottom-10 w-64 h-64 bg-[#1a5c4a]/5 rounded-full blur-3xl"></div>
                <div className="absolute -left-10 -top-10 w-48 h-48 bg-[#1a5c4a]/5 rounded-full blur-3xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div data-testid="practice-marquee" className="bg-[#1a5c4a] py-4 overflow-hidden">
        <div className="animate-marquee flex items-center whitespace-nowrap">
          {[...areas, ...areas].map((area, i) => (
            <span key={`marquee-${area.id}-${i}`} className="flex items-center">
              <span className="text-white font-medium text-lg mx-8 tracking-wide">{area.title}</span>
              <span className="text-white/40 text-xl mx-2">&#10038;</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
